<div id="popup">
  @if (stillGoing) {
    <p>Loading...</p>
  }
  @if (errorMessage) {
    <p id="error-message" style="color:red; white-space: pre">
      {{errorMessage}}
    </p>
  }
  @if (successMessage) {
    <p id="success-message" style="color:black; white-space: pre">
      {{successMessage}}
    </p>
  }

  <mat-dialog-actions align="end">
    @if (!stillGoing) {
      <button type="button" id="cancel-button" class="action-button" (click)="close()">CLOSE</button>
    }
  </mat-dialog-actions>
</div>
